/** @format */
import { Choice } from '@mpb-com/feather/components/atoms/choice';
import { Trans, useTranslation } from 'next-i18next';
import React from 'react';

import { Link } from '@toucan/client/shared/components/link';

import { ExplicitConsentTermsAndConditionsProps } from './types';

export const DEFAULT_TEST_ID = 'use-terms-and-conditons__checkbox';

export const ExplicitConsentTermsAndConditions = ({
    onChange,
    className,
    isChecked,
    openTermsHandler,
}: ExplicitConsentTermsAndConditionsProps) => {
    const { t } = useTranslation();

    const label = (
        <Trans
            components={{
                ['terms-page-link']: (
                    <Link
                        onClick={openTermsHandler}
                        data-testid="terms-and-conditions__open-modal-button"
                    />
                ),
            }}
        >
            {t(
                'I have read and agree to the <terms-page-link>MPB Terms of Use</terms-page-link>'
            )}
        </Trans>
    );

    return (
        <Choice
            label={label}
            name="terms-conditions"
            value="terms-conditions"
            checked={isChecked}
            onChange={onChange}
            className={className}
            data-testid="use-terms-and-conditons__checkbox"
        />
    );
};
